import Vue from 'vue';

import { ActionSheet, Field } from 'vant';

Vue.use(ActionSheet);
Vue.use(Field);